module.exports = __webpack_public_path__ + "img/logo-pick8.0cfd0ff8.png";